import React, { useEffect, useState } from "react";
import { Card, CardBody, CardExpandToggler } from "./../../components/card/card.jsx";
import Chart from "react-apexcharts";
import { apiUrl } from "../../config/config.js";
import { getChartOptions } from "../../components/dashboard/getChartOptions.js";
import MovementsLog from "../../components/dashboard/MovementsLog.jsx";

function Dashboard() {
	const [depositsAmount, setDepositsAmount] = useState(0);
	const [reserveCount, setReserveCount] = useState(0);
	const [customersCounts, setCustomersCounts] = useState(0);
	const [customerList, setCustomersList] = useState([]);
	const [purchaseList, setPurchaseList] = useState([]);
	const [statsData, setStatsData] = useState();
	const [chartOptions, setChartOptions] = useState(getChartOptions());

	useEffect(() => {
		fetchDashboardData();
	}, []);

	const fetchDashboardData = async () => {
		try {
			const response = await fetch(apiUrl + "/dashboardData", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (response.status === 200) {
				let data = await response.json();
				console.log("DASHBOARD DATA TESTING", data);
				setCustomersCounts(data.customersCount[0].count);
				setReserveCount(data.reserveCount[0].count);
				setDepositsAmount(Number(data.depositsSum[0].sum).toFixed(2));
				setCustomersList(data.customerList);
				setPurchaseList(data.purchaseList);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
		}
	};

	useEffect(() => {
		fetch("/assets/data/dashboard/stats.json")
			.then((res) => res.json())
			.then((result) => {
				setStatsData(result);
			});
	}, []);

	const counts = {
		PAGOS: depositsAmount,
		"CANTIDAD DE PAGOS": purchaseList.length,
		"CANTIDAD DE RESERVAS": reserveCount,
		"NÚMERO DE CLIENTES": customersCounts,
	};

	return (
		<div>
			<div className="row">
				{statsData &&
					statsData.length > 0 &&
					statsData.map((stat, index) => (
						<div className="col-xl-3 col-lg-6" key={index}>
							<Card className="mb-3">
								<CardBody>
									<div className="d-flex fw-bold small mb-3">
										<span className="flex-grow-1">{stat.title}</span>
										<CardExpandToggler />
									</div>
									<div className="row align-items-center mb-2">
										<div className="col-7">
											<h3 className="mb-0">{counts[stat.title]}</h3>
										</div>
										<div className="col-5">
											<div className="mt-n2">
												<Chart
													type={stat.chartType}
													height={stat.chartHeight}
													options={chartOptions[stat.chartType]}
													series={stat.chartData}
												/>
											</div>
										</div>
									</div>
								</CardBody>
							</Card>
						</div>
					))}
				<MovementsLog title={"ULTIMOS CLIENTES REGISTRADOS"} data={customerList} type={"customer"} />
				<MovementsLog title={"ULTIMAS COMPRAS REGISTRADAS"} data={purchaseList} type={"purchase"} />
			</div>
		</div>
	);
}

export default Dashboard;
